"use strict";
exports.__esModule = true;
var redux_observable_1 = require("redux-observable");
var EpicManager_1 = require("./EpicManager");
function getObservableExtension() {
    var epicMiddleware = redux_observable_1.createEpicMiddleware();
    var epicManager = EpicManager_1.getEpicManager(epicMiddleware);
    return {
        middleware: [epicMiddleware],
        onModuleAdded: function (module) {
            if (module.epics) {
                epicManager.add(module.epics);
            }
        },
        onModuleRemoved: function (module) {
            if (module.epics) {
                epicManager.remove(module.epics);
            }
        },
        dispose: function () {
            epicManager.dispose();
        }
    };
}
exports.getObservableExtension = getObservableExtension;
